<svelte:options customElement={{
  tag: 'modal-dialog',
  shadow: 'none',
  props: {
    open: { reflect: true, type: 'Boolean' },
    src: { reflect: true, type: 'String' },
    alt: { reflect: true, type: 'String' },
    trigger: { reflect: true, type: 'String' },
    type: { reflect: true, type: 'String' }
  }
}} />

<script>
  import { onMount, onDestroy } from 'svelte';

  /**
   * modal：モーダル
   * 画像・動画ページのモーダルパーツ
   * @prop {boolean} open - モーダル表示状態
   * @prop {string} src - 画像URL または YouTube embed URL
   * @prop {string} alt - 画像alt属性
   * @prop {string} trigger - トリガー要素のCSSセレクタ（クリックでモーダルを開く）
   * @prop {string} type - 'image'（デフォルト）| 'youtube'
   */
  export let open = false;
  export let src = '';
  export let alt = '';
  export let trigger = '';
  export let type = 'image';

  let triggerEl = null;

  function openModal() {
    open = true;
  }

  function close() {
    open = false;
  }

  function handleKeydown(e) {
    if (e.key === 'Escape') close();
  }

  function handleBackdropClick(e) {
    if (e.target === e.currentTarget) close();
  }

  onMount(() => {
    if (trigger) {
      triggerEl = document.querySelector(trigger);
      triggerEl?.addEventListener('click', openModal);
    }
  });

  onDestroy(() => {
    triggerEl?.removeEventListener('click', openModal);
  });
</script>

<svelte:window on:keydown={handleKeydown} />

{#if open}
  <div class="mod-modal-backdrop" on:click={handleBackdropClick} role="dialog" aria-modal="true">
    <div class="mod-modal" class:mod-modal--youtube={type === 'youtube'}>
      <button type="button" class="mod-modal-close" on:click={close} aria-label="閉じる">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="mod-modal-content" class:mod-modal-content--youtube={type === 'youtube'}>
        {#if type === 'youtube' && src}
          <div class="mod-modal-youtube">
            <iframe
              src={src}
              title="YouTube video"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        {:else if src}
          <img {src} {alt} class="mod-modal-img" />
        {/if}
        <slot></slot>
      </div>
    </div>
  </div>
{/if}

<style>
  .mod-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
  }

  .mod-modal {
    position: relative;
    max-width: 90vw;
    max-height: 90vh;
    background-color: #fff;
    border-radius: 5px;
    overflow: auto;
  }

  .mod-modal-close {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 36px;
    height: 36px;
    border: none;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 1.5rem;
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    transition: 0.3s;
  }

  .mod-modal-close:hover {
    background: rgba(0, 0, 0, 0.8);
  }

  .mod-modal-content {
    padding: 20px;
  }

  .mod-modal-img {
    display: block;
    max-width: 100%;
    height: auto;
  }

  .mod-modal--youtube {
    background-color: #000;
    width: min(90vw, 960px);
    max-height: none;
    overflow: visible;
  }

  .mod-modal-content--youtube {
    padding: 0;
  }

  .mod-modal-youtube {
    position: relative;
    width: 100%;
    padding-top: 56.25%; /* 16:9 */
  }

  .mod-modal-youtube iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
